import { render, staticRenderFns } from "./ClientEventsByDate.vue?vue&type=template&id=2326b104&scoped=true"
import script from "./ClientEventsByDate.vue?vue&type=script&lang=js"
export * from "./ClientEventsByDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2326b104",
  null
  
)

export default component.exports